var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPadlockOutlineIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gs1735thoa",
    width: "125.6%",
    height: "125.3%",
    x: "-12.8%",
    y: "-12.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 16,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.188235294 0 0 0 0 0.192156863 0 0 0 0 0.2 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.188235294 0 0 0 0 0.192156863 0 0 0 0 0.2 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    filter: "url(#gs1735thoa)",
    transform: "translate(-264 -94)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44 7.737c8.1 0 14.667 6.566 14.667 14.666v6.93h3.666c6.075 0 11 4.925 11 11v29.334c0 6.075-4.925 11-11 11H25.667c-6.075 0-11-4.925-11-11V40.333l.003-.288c.153-5.942 5.018-10.712 10.997-10.712h3.666v-6.93c0-8.1 6.567-14.666 14.667-14.666zm18.333 28.93H25.667c-2.025 0-3.667 1.641-3.667 3.666v29.334l.005.194c.101 1.935 1.702 3.472 3.662 3.472h36.666c2.025 0 3.667-1.641 3.667-3.666V40.333c0-2.025-1.642-3.666-3.667-3.666zM44 44l.288.004C50.23 44.157 55 49.02 55 55l-.004.288C54.843 61.23 49.98 66 44 66c-6.075 0-11-4.925-11-11s4.925-11 11-11zm0 7.333c-2.025 0-3.667 1.642-3.667 3.667s1.642 3.667 3.667 3.667l.195-.005c1.934-.102 3.472-1.702 3.472-3.662l-.005-.195c-.102-1.934-1.702-3.472-3.662-3.472zm0-36.666l-.244.01c-4.04.245-7.19 3.65-7.09 7.726v6.93h14.667v-6.93c.103-4.158-3.175-7.616-7.333-7.736z",
    transform: "translate(264 94)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPadlockOutlineIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/padlockOutlineIcon.779b29ca.svg";
export { ForwardRef as ReactComponent };